module.exports = __webpack_public_path__ + "media/icon/arrow-up-b23a6ae6.svg";